import React from "react";
import { Link } from "react-router-dom";
import Container from "../Container";

import "./index.scss";

export const Header: React.FC = () => {
    return (
        <header className="ec-header">
            <Container>
                <h1 className="logo-wrap">
                    <Link to="/">
                    <span className="logo">
                        <img
                            src="/assets/img/pr_tc/logo.png"
                            alt="西部ガスグループ"
                        />
                    </span>
                    <span className="logo-sub">公式オンラインショップ</span>
                    </Link>
                </h1>
            </Container>
        </header>
    );
};

export default Header;
